import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8648afa13e8bc11efc12651e92475250.jpg"
          alt="Atlanta Georgia luxury real estate neighborhood"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      {/* Content */}
      <div
        className={`relative z-10 w-full text-center px-6 max-w-5xl mx-auto transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#B8963E]/20 border border-[#B8963E]/60 text-[#D4AF70] text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-6">
          <i className="ri-map-pin-2-fill"></i>
          Atlanta · Duluth · Suwanee, Georgia
        </div>

        {/* Main Heading */}
        <h1 className="font-['Playfair_Display'] text-white text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-2">
          김산 부동산
        </h1>
        <p className="font-['Playfair_Display'] text-[#D4AF70] text-2xl md:text-3xl lg:text-4xl font-semibold italic mb-6">
          Shawn Kim Real Estate
        </p>

        {/* Subheading */}
        <p className="text-white/85 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-3">
          Over 30 years of trusted expertise in Atlanta, Duluth &amp; Suwanee real estate.
          Helping buyers, sellers, and investors achieve their goals.
        </p>
        <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto leading-relaxed mb-10">
          30년 이상의 경험으로 주택 매매, 상업용 부동산, 투자 컨설팅을 전문으로 도와드립니다.
        </p>

        {/* Stats */}
        <div className="flex flex-wrap items-center justify-center gap-8 mb-10">
          {[
            { value: '30+', label: 'Years Experience' },
            { value: '1,000+', label: 'Homes Sold' },
            { value: '#1', label: 'Duluth & Suwanee' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-['Playfair_Display'] text-[#D4AF70] text-3xl font-bold">{stat.value}</div>
              <div className="text-white/70 text-xs tracking-wide mt-1">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => handleScroll('#listings')}
            className="bg-[#B8963E] hover:bg-[#A07830] text-white px-8 py-3.5 rounded-md font-semibold text-sm tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Browse Listings
          </button>
          <button
            onClick={() => handleScroll('#contact')}
            className="border border-white/60 hover:border-white hover:bg-white/10 text-white px-8 py-3.5 rounded-md font-semibold text-sm tracking-wide transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Free Consultation
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-10 bg-white/30 animate-pulse"></div>
      </div>
    </section>
  );
}
